/* @flow */

export const FACET_TYPE_MULTI = "multi";
export const FACET_TYPE_NUMBER = "number";
export const FACET_TYPE_BOOL = "bool";

export type FacetDataType = "number" | "bool" | "multi" | "additional"; // "additional" is just another multi

export type FacetResult = {
    key: string;
    name?: string;
    values?: Array<{
        name: string;
        displayName?: string;
        amount: number;
    }>;
    numberMax?: string | undefined | null;
    numberMin?: string | undefined | null;
    numberUnit?: string | undefined | null;
    dataType?: FacetDataType;
};

export type FacetFilterMulti = {
    key: string;
    values: Array<string>;
};

export type FacetFilterNumeric = {
    key: string;
    range: [number | undefined | null, number | undefined | null] | null;
};

export type FacetFilterBool = {
    key: string;
    value: boolean;
};
